import { Component, Input, ViewChild } from '@angular/core';
import { DateHelper } from '@bryntum/grid';
import { BryntumDateTimeFieldComponent, BryntumGridModule } from '@bryntum/grid-angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContainerService } from '../../../../../shared/Container/container.service';
import { ContainerCompleteLegRequest } from '../../../../../shared/Container/model/ContainerCompleteLegRequest';
import { ToasterService } from '../../../../../shared/toaster/toaster.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-container-job-complete-modal',
  standalone: true,
  imports: [BryntumGridModule],
  templateUrl: './container-job-complete-modal.component.html',
  styleUrl: './container-job-complete-modal.component.scss'
})
export class ContainerJobCompleteModalComponent {

  @ViewChild('startDateTime')
  startDateTimeComponent: BryntumDateTimeFieldComponent | null = null;
  @ViewChild('endDateTime')
  endDateTimeComponent: BryntumDateTimeFieldComponent | null = null;
  completeButtonDisable: boolean = false;

  @Input() movementIds: number[] = [];

  startDateTimeConfig: Partial<BryntumDateTimeFieldComponent> = {
    value: new Date(),
    dateField: {
      format: 'DD/MM/YYYY'
    },
    timeField: {
      step: '15 min'
    }
  }

  endDateTimeConfig: Partial<BryntumDateTimeFieldComponent> = {
    value: DateHelper.add(new Date(), 1, 'hour'),
    dateField: {
      format: 'DD/MM/YYYY'
    },
    timeField: {
      step: '15 min'
    }
  }

  constructor(
    public activeModal: NgbActiveModal,
    private containerService: ContainerService,
    private toasterService: ToasterService) {

  }

  onStartDateTimeChange({ value }: { value: Date }) {
    if (!this.endDateTimeComponent || !this.startDateTimeComponent) {
      return;
    }
    if (DateHelper.isAfter(value, this.endDateTimeComponent.instance.value)) {
      this.startDateTimeComponent.instance.setError("The start cannot be after the end date and time");
      this.completeButtonDisable = true;
    } else {
      this.startDateTimeComponent.instance.clearError();
      this.completeButtonDisable = false;
    }
  }

  onEndDateTimeChange({ value }: { value: Date }) {
    if (!this.endDateTimeComponent || !this.startDateTimeComponent) {
      return;
    }
    if (DateHelper.isBefore(value, this.startDateTimeComponent.instance.value)) {
      this.endDateTimeComponent.instance.setError("The end cannot be after the start date and time");
      this.completeButtonDisable = true;
    } else {
      this.endDateTimeComponent.instance.clearError();
      this.completeButtonDisable = false;
    }
  }

  onComplete() {
    if (!this.endDateTimeComponent || !this.startDateTimeComponent || this.movementIds.length === 0) {
      return;
    }

    const model: ContainerCompleteLegRequest = {
      movementIds: this.movementIds,
      startDateTime: this.startDateTimeComponent.instance.value,
      endDateTime: this.endDateTimeComponent.instance.value,
    }

    this.containerService.completeContainerJob(model).subscribe({
      next: (response) => {
        this.activeModal.close(true);
        this.toasterService.showDefault("The selected container has been successfully updated!")
      },
      error: (errorResponse: HttpErrorResponse) => {
        this.toasterService.showDanger(errorResponse.error)
      }
    });
  }
}
